import * as StyledAlert from './styled/alert';

export const Alert = {
  Root: StyledAlert.Root,
  Content: StyledAlert.Content,
  Description: StyledAlert.Description,
  Icon: StyledAlert.Icon,
  Title: StyledAlert.Title,
};
